import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useContext } from "react";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { FaAddressCard, FaPhoneAlt } from "react-icons/fa";
import { MdEmail, MdWatchLater } from "react-icons/md";
import { useBackgroundImage } from "../utilities/mediautilities";
import { useTranslation } from "react-i18next"
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Contact = () => {
    const { schoolDetails } = useContext(schoolContext);
    const { t } = useTranslation()

    const bgUrl = useBackgroundImage(schoolDetails?.contact_us?.fileUrl);
    return (
        <>
            <div className="w-full">
                {/* Hero Section */}
                <section
                    className="relative bg-cover bg-center py-20 px-6"
                    style={{ backgroundImage: `url(${bgUrl})` }}
                >
                    <div className="absolute inset-0 bg-black/50"></div>
                    <div className="relative z-10 common-container">
                        <div className="rounded-lg text-left">
                            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-accent">
                                {t(I18N_KEYS.CONTACTUSPAGENAME)}
                            </h1>
                            <p className="text-lg md:text-xl text-accent">
                                <Link to="/" className="hover:text-primary transition-colors">
                                    {t(I18N_KEYS.HOMEPAGENAME)}
                                </Link>{" "}
                                &gt; {t(I18N_KEYS.CONTACTUSPAGENAME)}
                            </p>
                        </div>
                    </div>
                </section>
                {/* Contact Section */}
                {(schoolDetails?.address || schoolDetails?.contact_number || schoolDetails?.email || schoolDetails?.working_hours) &&
                    <section className="py-20 px-6 bg-gray-50">
                        <div className=" common-container grid grid-cols-1 md:grid-cols-2 gap-12">
                            {/* Contact Info */}
                            <motion.div
                                className="bg-gradient-to-br rounded-3xl shadow-2xl p-10 flex flex-col justify-between"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h2 className="text-3xl font-bold text-primary mb-8">
                                    {t(I18N_KEYS.CONTACTUSTITLE1)}
                                </h2>
                                <ul className="space-y-6 text-primary">
                                    {schoolDetails?.address &&
                                        <li className="flex items-start space-x-4 flex items-center">
                                            <span className="text-secondary text-2xl"><FaAddressCard /></span>
                                            <div>
                                                <strong>{t("address")}:</strong><br />
                                                {schoolDetails?.address}
                                            </div>
                                        </li>
                                    }
                                    {schoolDetails?.contact_number &&
                                        <li className="flex items-start space-x-4 flex items-center">
                                            <span className="text-secondary text-2xl"><FaPhoneAlt /></span>
                                            <div>
                                                <strong>{t("phone")}:</strong><br />
                                                {schoolDetails?.contact_number}
                                            </div>
                                        </li>
                                    }
                                    {schoolDetails?.email &&
                                        <li className="flex items-start space-x-4 flex items-center">
                                            <span className="text-secondary text-2xl"><MdEmail /></span>
                                            <div>
                                                <strong>{t("email")}:</strong><br />
                                                {schoolDetails?.email}
                                            </div>
                                        </li>
                                    }
                                    {schoolDetails?.working_hours &&
                                        <li className="flex items-start space-x-4 flex items-center">
                                            <span className="text-secondary text-2xl"><MdWatchLater /></span>
                                            <div>
                                                <strong>{t("working_hours")}:</strong><br />
                                                {schoolDetails?.working_hours}
                                            </div>
                                        </li>
                                    }
                                </ul>
                                <p className="mt-10 text-primary italic">
                                    {t(I18N_KEYS.CONTACTUSINFO)}
                                </p>
                            </motion.div>

                            {/* Contact Form */}
                            <motion.div
                                className="bg-accent rounded-3xl shadow-2xl p-10"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h2 className="text-3xl font-bold text-primary mb-8">
                                    {t(I18N_KEYS.CONTACTUSTITLE2)}
                                </h2>
                                <form className="space-y-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <input
                                            type="text"
                                            placeholder={t(I18N_KEYS.NAME)}
                                            className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary transition"
                                        />
                                        <input
                                            type="email"
                                            placeholder={t(I18N_KEYS.YOURMAIL)}
                                            className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary transition"
                                        />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder={t(I18N_KEYS.SUBJECT)}
                                        className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary transition"
                                    />
                                    <textarea
                                        rows="5"
                                        placeholder={t(I18N_KEYS.MESSAGE)}
                                        className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary transition"
                                    ></textarea>
                                    <button
                                        type="submit"
                                        className="bg-primary text-accent px-8 py-3 rounded-full font-semibold hover:bg-primary/90 transition transform hover:scale-105 shadow-lg"
                                    >
                                        {t(I18N_KEYS.SENDMESSAGEBUTTON)}
                                    </button>
                                </form>
                            </motion.div>
                        </div>
                    </section>
                }


                {/* Map Section */}
                {schoolDetails?.location &&
                    <section className="w-full h-96 mb-10">
                        <iframe
                            src={schoolDetails?.location}
                            className="w-full h-full border-0"
                            width="600"
                            height="450"
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </section>
                }
            </div>
        </>
    );
}

export default Contact